import { defineMessages } from 'react-intl';

export const i18n: {
	closeButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createNewPromptTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	requiredFieldsNote: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titleLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	titlePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	promptLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	promptPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	useCaseLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	useCasePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	roleLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rolePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	appLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	appPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	saveButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	copyTitlePrefix: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	closeButtonLabel: {
		id: 'rovo-conversation-actions.create-prompt-modal.close-button-label',
		defaultMessage: 'Close',
		description: 'Accessible label for the close button',
	},
	createNewPromptTitle: {
		id: 'rovo-conversation-actions.create-prompt-modal.title',
		defaultMessage: 'Create new prompt',
		description: 'Title for the create new prompt modal',
	},
	requiredFieldsNote: {
		id: 'rovo-conversation-actions.create-prompt-modal.required-fields-note',
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'Note about required fields in the create prompt form',
	},
	titleLabel: {
		id: 'rovo-conversation-actions.create-prompt-modal.title-label',
		defaultMessage: 'Title',
		description: 'Label for the title field in the create prompt modal form',
	},
	titlePlaceholder: {
		id: 'rovo-conversation-actions.create-prompt-modal.title-placeholder',
		defaultMessage: 'Enter a descriptive title for your prompt',
		description: 'Placeholder for the title input',
	},
	promptLabel: {
		id: 'rovo-conversation-actions.create-prompt-modal.prompt-label',
		defaultMessage: 'Prompt',
		description: 'Label for the prompt content field in the create prompt modal form',
	},
	promptPlaceholder: {
		id: 'rovo-conversation-actions.create-prompt-modal.prompt-placeholder',
		defaultMessage:
			'Type the prompt you want to create. Be clear and specific to get the best results.',
		description: 'Placeholder for the prompt textarea',
	},
	useCaseLabel: {
		id: 'rovo-conversation-actions.create-prompt-modal.use-case-label',
		defaultMessage: 'Use Case',
		description: 'Label for the use case dropdown in the create prompt modal form',
	},
	useCasePlaceholder: {
		id: 'rovo-conversation-actions.create-prompt-modal.use-case-placeholder',
		defaultMessage: 'Pick the closest use case.',
		description: 'Placeholder for the use case select',
	},
	roleLabel: {
		id: 'rovo-conversation-actions.create-prompt-modal.role-label',
		defaultMessage: 'Role',
		description: 'Label for the role dropdown in the create prompt modal form',
	},
	rolePlaceholder: {
		id: 'rovo-conversation-actions.create-prompt-modal.role-placeholder',
		defaultMessage: 'Who is this prompt intended for?',
		description: 'Placeholder for the role select',
	},
	appLabel: {
		id: 'rovo-conversation-actions.create-prompt-modal.app-label',
		defaultMessage: 'Apps',
		description: 'Label for the app dropdown in the create prompt modal form',
	},
	appPlaceholder: {
		id: 'rovo-conversation-actions.create-prompt-modal.app-placeholder',
		defaultMessage: 'Adding apps help your prompt answer more accurately.',
		description: 'Placeholder for the app select',
	},
	cancelButton: {
		id: 'rovo-conversation-actions.create-prompt-modal.cancel',
		defaultMessage: 'Cancel',
		description: 'Cancel button text in the create prompt modal',
	},
	createButton: {
		id: 'rovo-conversation-actions.create-prompt-modal.create',
		defaultMessage: 'Create',
		description: 'Create button text in the create prompt modal',
	},
	saveButton: {
		id: 'rovo-conversation-actions.create-prompt-modal.save',
		defaultMessage: 'Save',
		description: 'Save button text when editing an existing prompt',
	},
	createError: {
		id: 'rovo-conversation-actions.create-prompt-modal.create-error',
		defaultMessage: 'Something went wrong. Please try again.',
		description: 'Error message when creating a prompt fails',
	},
	copyTitlePrefix: {
		id: 'rovo-conversation-actions.create-prompt-modal.copy-title-prefix',
		defaultMessage: '[Copy] {title}',
		description: 'Title prefix when duplicating a prompt',
	},
});
